import { Box, Paper, TextField } from "@mui/material";
import React from "react";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";
import { DataGrid } from "@mui/x-data-grid";
import { LEAD_COURSE_ANALYTICS_TABLE_HEAD as columns } from "../../../components/datagrid/CRM/Analytics/LeadCourseAnalytics/LeadCourseAnalyticsTableHead";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Wrapper from "../../../components/Wrapper/Wrapper";

const data = [
    {
        serialNumber: 1,
        course: "Little Genie - 1 std.",
        paidAssessment: 133,
        assessment: 12,
        gccAssessment: 34,
        bdaAssessment: 22,
        foreignAssessment: 46,
        referralSchemeEmployee: 2,
        referralSchemeTrainer: 2,
        followUp: 10,
        personalMentorIndia: 10,
        personalMentorGcc: 10,
        vacationCourses: 10,
        admissionConfirmed: 10,
        totalSalesAmount: 10,
        advancePaid: 1000,
    },
];

export default function LeadCourseAnalytics() {
    const [gridSize, setGridSize] = React.useState(5);
    const [value, setValue] = React.useState(null);
    return (
        <div>
            <Wrapper
                title="Retain Call Analytics"
                Content={
                    <>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                padding: 2,
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Month"
                                    value={value}
                                    openTo="year"
                                    views={["year", "month", "day"]}
                                    onChange={(newValue) => {
                                        setValue(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} />
                                    )}
                                />
                            </LocalizationProvider>
                        </Box>

                        <Paper elevation={3}>
                            <Box width="100%">
                                <Box
                                    sx={{
                                        backgroundColor: "grey.200",
                                        borderRadius: "8px 8px 0 0",
                                        display: "flex",
                                        height: 44,
                                    }}
                                ></Box>
                                <DataGrid
                                    components={{ Toolbar: CustomGridToolbar }}
                                    // loading={loading}
                                    rows={data}
                                    columns={columns}
                                    autoHeight
                                    getRowId={(row) => row.serialNumber}
                                    pageSize={gridSize}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    onPageSizeChange={(newGridSize) =>
                                        setGridSize(newGridSize)
                                    }
                                />
                            </Box>
                        </Paper>
                    </>
                }
            />
        </div>
    );
}
